import {Offcanvas} from "react-bootstrap";
import {useState} from "react";
import style from "./SideBarOffCanvas.module.css";
import commonStyle from "../Style.module.css";
import useWebSocket from "react-use-websocket";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as AssetsService from "../../api/AssetsService";
import {defaultMetaphoricCardsCards} from "../methaphoricCards/DefaultMetaphoricCards";
import SideBarOffCanvasCustomMove from "./SideBarOffCanvasCustomMove";
import {useTranslation} from "react-i18next";
import GroupGameFieldOffCanvasGameSettings from "./GroupGameFieldOffCanvasGameSettings";
import {wsBaseUrl} from "../../api/ApiUtils";

export default function SideBarOffCanvas(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'sideBarOffCanvas' });
    const [selectedStack, setSelectedStack] = useState(0)
    const [sendButtonEnabled, setSendButtonEnabled] = useState(false)
    const [messageSent, setMessageSent] = useState(false)

    const [availableCards, setAvailableCards] = useState([])

    useEffectOnce(() => {
        AssetsService.getAvailableMetaphoricCards(setAvailableCards, () => {
            setAvailableCards(defaultMetaphoricCardsCards)
        })
    })

    const {
        sendJsonMessage,
    } = useWebSocket(wsBaseUrl + `ws/game/${props.gameId}/stream`, {
        shouldReconnect: () => true,
        share: true
    });

    function getSelectedStackData(stackId) {
        for (const stackData of availableCards) {
            if (stackData.id === stackId) {
                return stackData
            }
        }
    }

    function sendCards() {
        sendJsonMessage({
            message: {
                name: "cards",
                stack_data: getSelectedStackData(selectedStack),
                player_id: props.selectedPlayerId
            }
        }
        )
        setSendButtonEnabled(false)
        setMessageSent(true)
        trySetTimeout(() => {
            setMessageSent(false)
            setSendButtonEnabled(true)
        }, 10000)
    }

    const handleClose = () => props.onClose(false);
    return (
        <>
            <Offcanvas show={props.show} onHide={handleClose} placement={"end"}
                       style={{
                           backgroundColor: "var(--mentor-cabinet-background)"
                       }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title
                        style={{
                            borderBottom: "1px outset var(--mentor-cabinet-tips-header-border)"
                        }}
                    >{t('additionalInstruments')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <GroupGameFieldOffCanvasGameSettings
                        gameState={props.gameState}
                        selectedPlayerId={props.selectedPlayerId}
                    />
                    <br/>
                    <div className={style.cardsAndTitleContainer}>
                        <header className={commonStyle.h5Heading}>{t('metaphoricCards')}</header>
                        <div className={style.cardsContainer}>
                            {availableCards.map((stack) => {
                                return <div className={style.stackContainer} key={stack.id}>
                                    <div
                                        onClick={() => {
                                            setSelectedStack(stack.id)
                                            setSendButtonEnabled(true)
                                        }}
                                        className={style.stack}
                                        style={{
                                            backgroundImage: "url(" + stack.title_card_img + ")",
                                            border: stack.id === selectedStack ? "2px solid black" : "unset"
                                        }}
                                    />
                                </div>
                            })}
                        </div>
                        <button
                            disabled={!sendButtonEnabled || !props.selectedPlayerId}
                            onClick={sendCards}
                            className={commonStyle.defaultButtonColourAndText}
                            style={messageSent
                                ? {
                                    backgroundColor: "green",
                                    padding: "10px 10px 10px 10px"}
                                : {padding: "10px 10px 10px 10px"}}
                        >{messageSent ? t('sent') : props.selectedPlayerId ? t('sentToPlayer') : t('chosePlayer')}
                        </button>
                    </div>
                    <br/>
                    <SideBarOffCanvasCustomMove
                        gameId={props.gameId}
                        selectedPlayerId={props.selectedPlayerId}
                        cards={props.cards}
                    />

                </Offcanvas.Body>
            </Offcanvas>
        </>
    )

}